export default __webpack_public_path__ + "static/media/DiePraxis.ba75c0dc.jpg";